/* eslint-disable import/order */
import axios from 'axios';
import { objectToFormData } from 'utils/quickFunc';

export default class OfficeService {
  static async getTypes() {
    const response = await axios.get('offices/types');

    return response.data;
  }

  static async getOfficesBasicList() {
    const response = await axios.get('offices/basic');
    return response.data;
  }

  static async getOffices() {
    const response = await axios.get('offices');
    return response.data;
  }

  static async getOffice(officeId) {
    const response = await axios.get(`offices/${officeId}`);
    return response.data;
  }

  static async createOffice(data) {
    const response = await axios.post('offices', objectToFormData(data));
    return response.data;
  }

  static async updateOffice(data) {
    const response = await axios.post(`offices/${data.id}`, objectToFormData(data));
    return response.data;
  }

  static async deleteOffice(id) {
    const response = await axios.delete(`offices/${id}`);
    return response.data;
  }

  static async getUserAbilities() {
    const response = await axios.get('offices/abilities');
    return response.data;
  }
}
